import { api } from '../core';

interface UpdateTimelineEntryProviderResponse {
  success: boolean;
}

interface UpdateTimelineEntryProviderProps {
  abortController?: AbortController;
  entryId: string;
  providerId: string | null;
}

const timelineEntryProviderUpdateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateTimelineEntryProvider: builder.query<UpdateTimelineEntryProviderResponse, UpdateTimelineEntryProviderProps>({
      query: ({ abortController = new AbortController(), entryId, providerId }: UpdateTimelineEntryProviderProps) => ({
        url: 'timeline/entry/provider/update',
        method: 'POST',
        body: {
          entry_id: entryId,
          provider_id: providerId
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in updateTimelineEntryProvider in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyUpdateTimelineEntryProviderQuery } = timelineEntryProviderUpdateApi;
